if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.productsContainer = this.querySelector('.shop-the-look-products');
      this.slider = this.querySelector('.slider__list');

      if (this.productsContainer && this.slider) {
        this.products = this.productsContainer.querySelectorAll('.shop-the-look-product');
        this.init();
      }
    }

    shouldScroll() {
      const isMobile = window.innerWidth <= 749;
      const isListLayout = this.dataset.layout === 'list';
      return isMobile || isListLayout;
    }

    init() {
      this.products.forEach(product => {
        product.addEventListener('click', () => {
          const blockId = this.getBlockId(product);
          if (!blockId) return;
          this.setActiveById(blockId);

          if (this.shouldScroll()) {
            this.scrollToItem(blockId);
          }
        }, { passive: true });
      });

      const initialBlockId = this.getClosestBlockIdFromSlider() || this.getBlockId(this.products[0]);
      if (initialBlockId) {
        this.setActiveById(initialBlockId);

        if (window.innerWidth <= 749) {
          this.scrollToItem(initialBlockId);
        }
      }

      if (window.innerWidth <= 749) {
        this.boundHandleSliderScroll = this.handleSliderScroll.bind(this);
        this.slider.addEventListener('scroll', this.boundHandleSliderScroll, { passive: true });
      }
    }

    getBlockId(element) {
      if (!element) return null;
      const grabFromClasses = el => {
        if (!el) return null;
        const cls = Array.from(el.classList).find(c => c.startsWith('block-') || c.startsWith('list-item-'));
        return cls ? cls.replace(/^(block-|list-item-)/, '') : null;
      };

      let id = grabFromClasses(element);
      if (id) return id;

      const inner = element.querySelector('[class*="block-"], [class*="list-item-"]');
      return grabFromClasses(inner);
    }

    scrollToItem(blockId) {
      if (!blockId) return;

      const innerItem = this.slider.querySelector(`.list-item-${blockId}`);
      if (!innerItem) return;

      const slideItem = innerItem.closest('.slider__item');
      if (!slideItem) return;

      const sliderWidth = this.slider.clientWidth;
      const itemWidth = slideItem.offsetWidth;
      const itemLeft = slideItem.offsetLeft;

      const scrollPosition = itemLeft - (sliderWidth / 2) + (itemWidth / 2);

      this.slider.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });

      const sliderRect = this.slider.getBoundingClientRect();
      const margin = 20;

      const rect = this.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (isVisible) {
        window.scrollTo({
          top: window.scrollY + sliderRect.top - (window.innerHeight - sliderRect.height) + margin,
          behavior: 'smooth'
        });
      }    
    }

    setActiveById(blockId) {
      this.products.forEach(product => {
        const id = this.getBlockId(product);
        product.classList.toggle('active', id === blockId);
      });

      const allInner = this.slider.querySelectorAll('[class*="list-item-"]');
      allInner.forEach(inner => {
        const id = this.getBlockId(inner);
        const isActive = id === blockId;
        inner.classList.toggle('active', isActive);

        const li = inner.closest('.slider__item');
        if (li) li.classList.toggle('active', isActive);
      });
    }

    getClosestBlockIdFromSlider() {
      const sliderCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;

      let closestLi = null;
      let closestDistance = Infinity;

      const slideItems = this.slider.querySelectorAll('.slider__item');
      slideItems.forEach(li => {
        const liCenter = li.offsetLeft + li.offsetWidth / 2;
        const distance = Math.abs(sliderCenter - liCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestLi = li;
        }
      });

      if (!closestLi) return null;
      const inner = closestLi.querySelector('[class*="list-item-"]');
      return this.getBlockId(inner);
    }

    handleSliderScroll() {
      const blockId = this.getClosestBlockIdFromSlider();
      if (blockId) this.setActiveById(blockId);
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}
